<ng-container *transloco="let t">
  @if (availableVariants$ | async; as variants) {
    <section
      class="featured-details-card"
      [class.mobile]="(biggerThan$ | async)?.xs"
      [class.widescreen]="(biggerThan$ | async)?.mobileL">
      <span class="fixed-space-4" aria-hidden="true"></span>
      <app-product-reviews-stats
        [model]="model"
        (click)="scrollToReviews($event)"></app-product-reviews-stats>
      <app-product-best-variants
        [id]="productId"
        [model]="model"></app-product-best-variants>
      @if (variants.color.length > 0) {
        <app-product-color-variants
          [id]="productId"
          [model]="model"
          displayMode="icon"
          [showLabel]="true"></app-product-color-variants>
      }
      @if (variants.storage.length > 0) {
        <app-product-storage-variants
          [id]="productId"
          [model]="model"></app-product-storage-variants>
      }
      @if (variants.screen_size.length > 1) {
        <app-product-screen-size-variants
          [id]="productId"
          [model]="model"></app-product-screen-size-variants>
      }
      @if (variants.sim.length > 1) {
        <app-product-sim-variants [id]="productId" [model]="model" />
      }
      @if (category === 'LAPTOP') {
        <app-product-keyboard-variants
          [id]="productId"
          [model]="model"></app-product-keyboard-variants>
      }
      @if (category === 'TABLET' && variants.wifi_cellular.length) {
        <app-product-network-variants
          [id]="productId"
          [model]="model"></app-product-network-variants>
      }
      @if (category === 'WATCH') {
        <app-product-strap-variants
          [id]="productId"
          [model]="model"></app-product-strap-variants>
      }
      <app-product-condition-variants
        [id]="productId"
        [model]="model"
        [category]="category"></app-product-condition-variants>
      <app-product-insurance-options [id]="productId"></app-product-insurance-options>
    </section>
  }

  @if (!(availableVariants$ | async) || model === null) {
    <section>
      <popsy-skeleton class="skeleton-title"></popsy-skeleton>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <ng-container>
        <h2 class="skeleton-label text-gray-05">{{ t('txt_label_best_deails') }}</h2>
        <span class="fixed-space-16" aria-hidden="true"></span>
        <div class="flex">
          <popsy-skeleton class="skeleton-pill"></popsy-skeleton>
          <span class="fixed-space-24" aria-hidden="true"></span>
          <popsy-skeleton class="skeleton-pill"></popsy-skeleton>
          <span class="fixed-space-24" aria-hidden="true"></span>
          <popsy-skeleton class="skeleton-pill"></popsy-skeleton>
          <span class="fixed-space-24" aria-hidden="true"></span>
        </div>
      </ng-container>
      <ng-container>
        <span class="fixed-space-12" aria-hidden="true"></span>
        <h2 class="skeleton-label text-gray-05">{{ t('hint_color') }}</h2>
        <span class="fixed-space-16" aria-hidden="true"></span>
        <div class="flex">
          <popsy-skeleton class="skeleton-circle"></popsy-skeleton>
          <span class="fixed-space-24" aria-hidden="true"></span>
          <popsy-skeleton class="skeleton-circle"></popsy-skeleton>
          <span class="fixed-space-24" aria-hidden="true"></span>
          <popsy-skeleton class="skeleton-circle"></popsy-skeleton>
          <span class="fixed-space-24" aria-hidden="true"></span>
        </div>
      </ng-container>
      <ng-container>
        <span class="fixed-space-12" aria-hidden="true"></span>
        <h2 class="skeleton-label text-gray-05">{{ t('hint_storage_size') }}</h2>
        <span class="fixed-space-16" aria-hidden="true"></span>
        <div class="flex">
          <popsy-skeleton class="skeleton-pill"></popsy-skeleton>
          <span class="fixed-space-24" aria-hidden="true"></span>
          <popsy-skeleton class="skeleton-pill"></popsy-skeleton>
          <span class="fixed-space-24" aria-hidden="true"></span>
          <popsy-skeleton class="skeleton-pill"></popsy-skeleton>
          <span class="fixed-space-24" aria-hidden="true"></span>
        </div>
      </ng-container>
      <ng-container>
        <span class="fixed-space-12" aria-hidden="true"></span>
        <h2 class="skeleton-label text-gray-05">{{ t('label_condition') }}</h2>
        <span class="fixed-space-16" aria-hidden="true"></span>
        <div class="flex">
          <popsy-skeleton class="skeleton-pill"></popsy-skeleton>
          <span class="fixed-space-24" aria-hidden="true"></span>
          <popsy-skeleton class="skeleton-pill"></popsy-skeleton>
          <span class="fixed-space-24" aria-hidden="true"></span>
          <popsy-skeleton class="skeleton-pill"></popsy-skeleton>
          <span class="fixed-space-24" aria-hidden="true"></span>
        </div>
      </ng-container>
      <ng-container>
        <span class="fixed-space-12" aria-hidden="true"></span>
        <h2 class="skeleton-label text-gray-05">{{ t('content_label') }}</h2>
        <span class="fixed-space-16" aria-hidden="true"></span>
        <div class="flex">
          <popsy-skeleton class="skeleton-pill"></popsy-skeleton>
          <span class="fixed-space-24" aria-hidden="true"></span>
          <popsy-skeleton class="skeleton-pill"></popsy-skeleton>
          <span class="fixed-space-24" aria-hidden="true"></span>
        </div>
      </ng-container>
    </section>
  }
</ng-container>
